var _defs, _g, _line, _g2, _line2, _line3, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewCeilingToFloor1TrackFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "214px",
    height: "230px",
    viewBox: "0 -7.7 571 614",
    enableBackground: "new 0 -7.7 571 614",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t\t@font-face {\r\n\t\t\tfont-family: \"proximanova-nova\";\r\n\r\n\t\t\tsrc: url('https://doopsalta2.com/Fonts/proxima-nova-three.woff2') format('woff2'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.woff') format('woff'),\r\n\t\t\t\turl('https://doopsalta2.com/Fonts/proxima-nova-three.otf') format('opentype');\r\n\t\t\tfont-style: normal;\r\n\t\t\t}\r\n\t\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 34.5,
    y1: 25.3,
    x2: 34.5,
    y2: 586.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "25.5,27.9 34.5,12.3 43.5,27.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "25.5,583.8 34.5,599.3 43.5,583.8  "
  }))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 601.5,
    x2: 460,
    y2: 601.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 133,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 156.1,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 11,
    x2: 460,
    y2: 11
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.6256,
    x1: 50,
    y1: 88,
    x2: 410,
    y2: 88
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M471.2,6.3c-0.4-1-0.6-2.1-0.6-3.2c0-1.2,0.2-2.2,0.6-3.2c0.4-1,1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6 c1-0.4,2-0.6,3.1-0.6c2.5,0,4.4,1,5.8,3L482.7-1c-0.4-0.7-1.1-1.2-1.8-1.6c-0.8-0.4-1.6-0.6-2.4-0.6c-1.7,0-3.1,0.6-4.2,1.7 s-1.7,2.7-1.7,4.5c0,1.2,0.3,2.3,0.8,3.2s1.2,1.7,2.1,2.2c0.9,0.5,1.9,0.8,3,0.8c0.9,0,1.7-0.2,2.4-0.6s1.4-1,1.8-1.6l1.6,0.9 c-1.5,2-3.4,3.1-5.8,3.1c-1.1,0-2.1-0.2-3.1-0.6c-1-0.4-1.8-0.9-2.5-1.6C472.2,8.1,471.7,7.3,471.2,6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M489.1,10.7V-4.6h10.1v1.7H491V2h8v1.7h-8V9h8.1v1.7H489.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M504.5,10.7V-4.6h1.9v15.3H504.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M512,10.7V-4.6h1.9V9h7.1v1.7H512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M525.9,10.7V-4.6h1.9v15.3H525.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M533.7,10.7V-4.6h2l8.8,12v-12h1.9v15.3h-1.8l-8.9-12.2v12.2H533.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M552.3,6.3c-0.4-1-0.6-2.1-0.6-3.3s0.2-2.3,0.6-3.3s1-1.8,1.7-2.5c0.7-0.7,1.5-1.2,2.5-1.6 c1-0.4,2-0.6,3.1-0.6c2.4,0,4.4,1,6,2.9l-1.5,1c-0.5-0.6-1.1-1.2-1.9-1.5c-0.8-0.4-1.6-0.6-2.5-0.6c-1.7,0-3.1,0.6-4.2,1.7 s-1.7,2.7-1.7,4.5c0,1.2,0.3,2.3,0.8,3.2c0.5,1,1.2,1.7,2.1,2.2c0.9,0.5,1.9,0.8,3,0.8c0.8,0,1.6-0.2,2.4-0.5 c0.7-0.3,1.3-0.7,1.8-1.2V4.5h-5.3V2.8h7.2v5.5c-0.7,0.8-1.6,1.5-2.7,1.9s-2.2,0.7-3.4,0.7c-1.1,0-2.1-0.2-3.1-0.6 c-1-0.4-1.8-0.9-2.5-1.6C553.2,8.1,552.7,7.3,552.3,6.3z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M470.6,601.2v-15.3h10.1v1.7h-8.1v4.9h8v1.7h-8v7H470.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M485.3,601.2v-15.3h1.9v13.6h7.1v1.7H485.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M499.5,597.6c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S500.2,598.8,499.5,597.6z M500.6,593.6c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C501.1,590.2,500.6,591.7,500.6,593.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M519.4,597.6c-0.6-1.2-0.9-2.6-0.9-4.1s0.3-2.8,0.9-4.1c0.6-1.2,1.5-2.2,2.7-2.8s2.5-1,4-1 c1.5,0,2.8,0.3,4,1c1.2,0.7,2.1,1.6,2.7,2.8c0.6,1.2,1,2.6,1,4.1s-0.3,2.8-1,4.1c-0.6,1.2-1.5,2.2-2.7,2.8c-1.2,0.7-2.5,1-4,1 c-1.5,0-2.8-0.3-4-1S520.1,598.8,519.4,597.6z M520.5,593.6c0,1.2,0.2,2.2,0.7,3.2c0.5,0.9,1.1,1.7,2,2.2c0.9,0.5,1.9,0.8,3,0.8 s2.1-0.3,3-0.8c0.9-0.5,1.5-1.3,2-2.2s0.7-2,0.7-3.2c0-1.8-0.5-3.3-1.6-4.5c-1-1.2-2.4-1.8-4.1-1.8c-1.7,0-3.1,0.6-4.1,1.8 C521,590.2,520.5,591.7,520.5,593.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M539,601.2v-15.3h6.2c1.4,0,2.6,0.4,3.5,1.3c0.9,0.8,1.3,2,1.3,3.4c0,0.7-0.1,1.3-0.3,1.8 c-0.2,0.6-0.5,1-0.9,1.4c-0.4,0.4-0.8,0.7-1.3,0.9s-1,0.3-1.5,0.4l4.1,6.2h-2.3l-3.9-6.1h-3.1v6.1H539z M540.9,593.4h4 c0.9,0,1.6-0.3,2.2-0.8c0.6-0.5,0.9-1.3,0.9-2.1s-0.3-1.6-0.9-2.1c-0.6-0.5-1.3-0.8-2.2-0.8h-4V593.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCeilingToFloor1TrackFull);
export default __webpack_public_path__ + "static/media/new_CeilingToFloor1_track_full.b5cf7ce1ab15556f79c552772c2859f3.svg";
export { ForwardRef as ReactComponent };